import React from 'react';
import {makeStyles} from '@material-ui/core';
import Offer from "./offer";
import Expertise from "./expertise";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundImage: 'url(/image/topBand/bgBand.png)',
        backgroundSize: '100% 100%',
        padding: '100px 15%',
        [theme.breakpoints.only('xs')]: {
            padding: '50px 5%',
        },
    },
    spacer: {
        height: 50
    }
}));

const OfferAndExpertiseContainer = React.forwardRef((props, ref) => {
    const classes = useStyles();

    return (
        <div className={classes.root} ref={ref}>
            <Offer/>
            <div className={classes.spacer}/>
            <Expertise/>
        </div>
    )
});

export default OfferAndExpertiseContainer